import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-gray-custom-900 border-t border-gray-custom-800">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://cdn.wrappedbot.com/overseerpfp.jpg" 
                alt="Overseer Logo" 
                className="h-12 w-12 rounded-xl"
              />
            </Link>
            <p className="text-gray-custom-400 mb-4">
              The ultimate Discord bot for server management, moderation, and community engagement.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://discord.gg/overseer" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-custom-400 hover:text-white transition-colors"
              >
                Discord
              </a>
              <a 
                href="https://twitter.com/overseerbot" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-custom-400 hover:text-white transition-colors"
              >
                Twitter
              </a>
              <a 
                href="https://github.com/overseerbot" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-custom-400 hover:text-white transition-colors"
              >
                GitHub
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-gray-custom-100 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-custom-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/docs" className="text-gray-custom-400 hover:text-white transition-colors">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/premium" className="text-gray-custom-400 hover:text-white transition-colors">
                  Premium
                </Link>
              </li>
              <li>
                <Link to="/beta" className="text-gray-custom-400 hover:text-white transition-colors">
                  Beta
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold text-gray-custom-100 mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/legal/terms" className="text-gray-custom-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy" className="text-gray-custom-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-custom-800 mt-12 pt-8 text-center text-gray-custom-400">
          <p>© {new Date().getFullYear()} Overseer. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 